import {
  downloadExportedFiscalInterestBalance,
  getFiscalInterestBalanceList,
  getAccountingInterestBalanceList,
  downloadAccountingInterestBalance
} from 'src/services/interestBalanceService';
import { asyncActionCreator } from 'src/utils/loadingUtils';
import getOptionsFromState from 'src/utils/balanceUtils';
import {
  selectFiscalInterestBalanceQueryOptions,
  selectAccountingInterestBalanceQueryOptions
} from '../selectors/interestBalanceSelectors';
import { showMessage } from './snackBarActions';
// FISCAL
export const LOAD_FISCAL_INTEREST_BALANCE = asyncActionCreator(
  'LOAD_FISCAL_INTEREST_BALANCE'
);
export const DOWNLOAD_FISCAL_INTEREST_BALANCE = asyncActionCreator(
  'DOWNLOAD_FISCAL_INTEREST_BALANCE'
);
export const CLEAR_FISCAL_INTEREST_BALANCE = 'CLEAR_FISCAL_INTEREST_BALANCE';
export const SAVE_FISCAL_INTEREST_BALANCE_OPTIONS =
  'SAVE_FISCAL_INTEREST_BALANCE_OPTIONS';
export const CLEAR_FISCAL_INTEREST_BALANCE_OPTIONS =
  'CLEAR_FISCAL_INTEREST_BALANCE_OPTIONS';

// ACCOUNTING
export const LOAD_ACCOUNTING_INTEREST_BALANCE = asyncActionCreator(
  'LOAD_ACCOUNTING_INTEREST_BALANCE'
);
export const DOWNLOAD_ACCOUNTING_INTEREST_BALANCE = asyncActionCreator(
  'DOWNLOAD_ACCOUNTING_INTEREST_BALANCE'
);
export const CLEAR_ACCOUNTING_INTEREST_BALANCE =
  'CLEAR_ACCOUNTING_INTEREST_BALANCE';
export const SAVE_ACCOUNTING_INTEREST_BALANCE_OPTIONS =
  'SAVE_ACCOUNTING_INTEREST_BALANCE_OPTIONS';
export const CLEAR_ACCOUNTING_INTEREST_BALANCE_OPTIONS =
  'CLEAR_ACCOUNTING_INTEREST_BALANCE_OPTIONS';

// FISCAL ACTIONS
export const clearFiscalInterestBalanceOptions = () => dispatch => {
  dispatch({ type: CLEAR_FISCAL_INTEREST_BALANCE_OPTIONS });
};

export const loadFiscalInterestBalance = options => async (
  dispatch,
  getState
) => {
  try {
    dispatch({ type: LOAD_FISCAL_INTEREST_BALANCE.start });

    dispatch({
      type: SAVE_FISCAL_INTEREST_BALANCE_OPTIONS,
      options
    });
    const reqOptions = getOptionsFromState(
      selectFiscalInterestBalanceQueryOptions,
      getState
    );

    const fiscalInterestBalance = await getFiscalInterestBalanceList(
      reqOptions
    );

    return dispatch({
      type: LOAD_FISCAL_INTEREST_BALANCE.success,
      ...fiscalInterestBalance
    });
  } catch (error) {
    dispatch(showMessage({ message: error.message, variant: 'error' }));
    return dispatch({ type: LOAD_FISCAL_INTEREST_BALANCE.failure });
  }
};

export const downloadExcelFiscalInterestBalance = options => async (
  dispatch,
  getState
) => {
  try {
    dispatch({
      type: DOWNLOAD_FISCAL_INTEREST_BALANCE.start
    });

    dispatch({
      type: SAVE_FISCAL_INTEREST_BALANCE_OPTIONS,
      options
    });

    const reqOptions = getOptionsFromState(
      selectFiscalInterestBalanceQueryOptions,
      getState
    );
    await downloadExportedFiscalInterestBalance(reqOptions);

    return dispatch({
      type: DOWNLOAD_FISCAL_INTEREST_BALANCE.success
    });
  } catch (error) {
    dispatch(showMessage({ message: error.message, variant: 'error' }));
    return dispatch({ type: DOWNLOAD_FISCAL_INTEREST_BALANCE.failure });
  }
};

// ACCOUNTING ACTIONS
export const clearAccountingInterestBalanceOptions = () => dispatch => {
  dispatch({ type: CLEAR_ACCOUNTING_INTEREST_BALANCE_OPTIONS });
};

export const clearAccountingInterestBalance = () => dispatch => {
  dispatch({ type: CLEAR_ACCOUNTING_INTEREST_BALANCE });
};

export const loadAccountingInterestBalance = options => async (
  dispatch,
  getState
) => {
  try {
    dispatch({ type: LOAD_ACCOUNTING_INTEREST_BALANCE.start });

    dispatch({
      type: SAVE_ACCOUNTING_INTEREST_BALANCE_OPTIONS,
      options
    });
    const reqOptions = getOptionsFromState(
      selectAccountingInterestBalanceQueryOptions,
      getState
    );

    const accountingInterestBalance = await getAccountingInterestBalanceList(
      reqOptions
    );

    return dispatch({
      type: LOAD_ACCOUNTING_INTEREST_BALANCE.success,
      ...accountingInterestBalance
    });
  } catch (error) {
    dispatch(showMessage({ message: error.message, variant: 'error' }));
    return dispatch({
      type: LOAD_ACCOUNTING_INTEREST_BALANCE.failure,
      error: error.message
    });
  }
};

export const downloadExcelAccountingInterestBalance = options => async (
  dispatch,
  getState
) => {
  try {
    dispatch({
      type: DOWNLOAD_ACCOUNTING_INTEREST_BALANCE.start
    });

    dispatch({
      type: SAVE_ACCOUNTING_INTEREST_BALANCE_OPTIONS,
      options
    });

    const reqOptions = getOptionsFromState(
      selectAccountingInterestBalanceQueryOptions,
      getState
    );
    await downloadAccountingInterestBalance(reqOptions);

    return dispatch({
      type: DOWNLOAD_ACCOUNTING_INTEREST_BALANCE.success
    });
  } catch (error) {
    dispatch(showMessage({ message: error.message, variant: 'error' }));
    return dispatch({ type: DOWNLOAD_ACCOUNTING_INTEREST_BALANCE.failure });
  }
};
